import { render, staticRenderFns } from "./PagerButtons.vue?vue&type=template&id=7c03c19d&"
import script from "./PagerButtons.vue?vue&type=script&lang=js&"
export * from "./PagerButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports